/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ProblemDetails,
} from '../models/index';
import {
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface ApiAttendanceLogsIdDeleteRequest {
    id: string;
    xTenantID?: number;
}

/**
 * 
 */
export class AttendanceLogsApi extends runtime.BaseAPI {

    /**
     * Deletes an attendance / absence record by id. Teacher-scoped delete remains on DELETE /api/teachers/{teacherId}/attendance-log/{id}.
     * Delete an attendance log (admin)
     */
    async apiAttendanceLogsIdDeleteRaw(requestParameters: ApiAttendanceLogsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiAttendanceLogsIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/attendance-logs/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes an attendance / absence record by id. Teacher-scoped delete remains on DELETE /api/teachers/{teacherId}/attendance-log/{id}.
     * Delete an attendance log (admin)
     */
    async apiAttendanceLogsIdDelete(requestParameters: ApiAttendanceLogsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAttendanceLogsIdDeleteRaw(requestParameters, initOverrides);
    }

}
